export default __webpack_public_path__ + "static/company-profile-overview-buyer-view-2d00346bf1d0964cb5813fa7aac0de92.png";